import React from 'react'
import './AnnoucementSlice.css'
import { renderStatementWithKaTeX } from '../../../Status';

const AnnoucementSlice = ({Post}) => {

    const parts = Post.Date.split(' ');
const monthDay = `${parts[0]} ${parts[1]}`; // "August 3"
const year = parts[2]; // "2025"
  return (
    <div className='AnnoucementSlice'>
        <div className="Date">
            <h1>{monthDay}</h1>
            <h1>{year}</h1>
        </div>
        <div className="Content">
            <div className="Title">
                <h1>{Post.Title}</h1>
                <span>{Post.Type}</span>
            </div>
            {/*<p>{Post.Content}</p>*/}
            
                        <div className='AnnoucementSlice-content'>{renderStatementWithKaTeX(Post.Content)}</div>

            <h3>Posted By : {Post.Poster.name}</h3>
        </div>

    </div>
  )
}

export default AnnoucementSlice
